module.exports = __webpack_public_path__ + "static/media/section4.b7aea9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section4.png
// module id = 300
// module chunks = 0